/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import isEqual from "react-fast-compare";
import { createSelectorCreator, defaultMemoize } from "reselect";

export const createDeepEqualSelector = createSelectorCreator(defaultMemoize, {
    equalityCheck: isEqual,
    resultEqualityCheck: isEqual
});
